var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOverview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8825",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M2.95 16.464a1.33 1.33 0 0 1 0-.928 14.333 14.333 0 0 1 26.5 0c.112.3.112.629 0 .928a14.333 14.333 0 0 1-26.5 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8825",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M16.2 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
})));
export { SvgOverview as ReactComponent };
export default __webpack_public_path__ + "459e0cbfe7c0a2e3130ea0e68f08f48f.svg";